import axios                                   from 'axios';
import {getUserToken, getProperty, getAppLang} from "../../../../utils";
import {RESERVATION_UPDATE_MAIL} from "../../../../constants/api.constants";


export function sendReservationMail(param) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language' : getAppLang()
        },
        body: {
            params: {
                property_id: getProperty(),
                booking_id: param.booking_id
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'RESERVATION_UPDATE_MAIL',
            payload: axios.post(RESERVATION_UPDATE_MAIL, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function reservationClearState() {
    return dispatch => {
        dispatch({
            type: 'RESERVATION_UPDATE_MAIL_CLEAR',
        })
    }
}